import { render, staticRenderFns } from "./DetailsMonthlyPayment.vue?vue&type=template&id=150f15bc&scoped=true&"
import script from "./DetailsMonthlyPayment.vue?vue&type=script&lang=js&"
export * from "./DetailsMonthlyPayment.vue?vue&type=script&lang=js&"
import style0 from "./DetailsMonthlyPayment.vue?vue&type=style&index=0&id=150f15bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f15bc",
  null
  
)

export default component.exports